module.exports = __webpack_public_path__ + "static/media/calendar.adc4fccc.svg";